"use strict";

jQuery(function($) {
    var sort_loading = false;
    var loading = false;


    $( document ).on( 'change', '[data-filter-menu-item-select]', function ( e ) {
        if ( !$( '[data-filter-target]' ).length ) {
            return;
        }

        var $menu = $( e.target );

        // trigger filter on click event to update the list
        $( "[data-filter-menu-item-id='" + $menu.val() + "']" ).trigger( "click" );
    });


    // filter list when clicking on a button in the filter menu
    $( document ).on( 'click', '[data-filter-menu] a', function ( e, history_trigger ) {
        e.preventDefault();

        if ( !$( '[data-filter-target]' ).length || $( '[data-filter-menu] [data-loading-icon]' ).length ) {
            return;
        }

        var $button             = $( e.target ),
            $filter_menu        = $button.closest( "[data-filter-menu]" ),
            $filter_menu_sort   = $( ".selected[data-filter-menu-sort]" ),
            $filter_menu_mobile = $filter_menu.find( "[data-filter-menu-item-select]" ),
            url                 = $button.attr( "href" ),
            type                = $filter_menu.data( "filter-menu" ),
            selected_id         = $button.data( "filter-menu-item-id" ),
            selected_type       = $button.data( "filter-menu-item-type" ),
            sort_order          = '',
            button_text         = $button.html(),
            loading_icon        = ' <span data-loading-icon class="loading-icon"></span>';

        var scroll_target     = "[data-filter-target]";
        var scroll_difference = 0;
        if( $( '[data-filter-target-custom]' ).length ) {
            scroll_target = "[data-filter-target-custom]";
        }

        if( $( document ).scrollTop() > $( scroll_target ).offset().top ) {

            if( $filter_menu.hasClass( 'fixed' ) ) {
                scroll_difference = $( 'header.header' ).height();
            }

            $('html, body').animate({
                scrollTop: ( $( scroll_target ).offset().top - scroll_difference )
            }, 1000 );
        }

        // get the selected sort order value
        if ( $filter_menu_sort.length ) {
            sort_order = $filter_menu_sort.data( "filter-menu-sort" );
        }

        // set the selected value for the mobile version too
        if ( $filter_menu_mobile.length ) {
            $filter_menu_mobile.val( selected_id );
            $filter_menu_mobile.after( loading_icon );
        }

        // add loading icon
        loading = true;

        if (!sort_loading) {
            $button.html(button_text + loading_icon);
        }

        $filter_menu.find( "a" ).removeClass( "selected" );
        $button.addClass( "selected" );

        // only push to history if it wasn't triggered by popstate event and a url is present for the button
        if( url.length && !history_trigger ) {

            if( sort_order.length ) {
                url = url + ( url.indexOf( "?" ) > 0 ? "&" : "?" ) + "filter_sort=" + sort_order;
            }

            history.pushState( { 'selected_id' : selected_id, 'selected_type' : selected_type, 'sort_order' : sort_order }, null, url );
        }

        $.ajax( {
            url      : themevars.ajaxurl,
            data     : {
                action        : 'filter_list',
                type          : type,
                post_id       : themevars.post_id,
                selected_id   : selected_id,
                selected_type : selected_type,
                sort_order    : sort_order
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( result ) {
            loading = false;
            sort_loading = false;
            // replace loading icon with text
            $( '[data-loading-icon]' ).remove();
            $button.html( button_text );
            $( '[data-filter-menu-sort-text]' ).html( $( '[data-filter-menu-sort].selected' ).html() );

            var $target = $('[data-filter-target]');
            $target.empty();

            // update load more button
            if( undefined !== result.data.load_more_button ) {
                $( '[data-msp-lm-button-container]' ).html( result.data.load_more_button );
            } else {
                $( 'a[data-msp-lm-button]' ).remove();
            }

            if (  true !== result.success || undefined === result.data.posts ) {
                $target.append( '<div class="text-center no-results-message">Geen resultaten</div>' );
                return;
            }

            $target.append( result.data.posts );
        } );
    } );


    // add initial page load of filter menu to history with pushState for back button functionality
    if( $( '[data-filter-menu] li.selected' ).length ) {
        var $button       = $( '[data-filter-menu] a.selected' ),
            filter_url    = $button.attr( "href" ),
            selected_id   = $button.data( "filter-menu-item-id" ),
            selected_type = $button.data( "filter-menu-item-type" ),
            sort_order    = '',
            $filter_menu_sort  = $( ".selected[data-filter-menu-sort]" );

        if ( $filter_menu_sort.length ) {
            sort_order = $filter_menu_sort.data( "filter-menu-sort" );
        }

        if( filter_url.length ) {
            history.pushState( { 'selected_id' : selected_id, 'selected_type' : selected_type, 'sort_order' : sort_order }, null, filter_url );
        }
    }


    // Revert to a previously saved state
    window.addEventListener( 'popstate', function( event ) {
        if( event.sort_order ) {
            $( '[data-filter-menu-sort]' ).removeClass('selected');
            $( "[data-filter-menu-sort='" + event.state.sort_order + "']" ).addClass( "selected" );
        }

        if( event.state && event.state.selected_id ) {
            $( "[data-filter-menu-item-id='" + event.state.selected_id + "']" ).trigger( "click", [ true ] );
        }
    });

    // Add loading icon
    $(document).on('click', '[data-filter-menu-sort]', function(e) {

        if ( !$('[data-filter-target]' ).length ) {
            return;
        }

        var $button      = $( e.target );
        var loading_icon = ' <span data-loading-icon class="loading-icon"></span>';

        // set button selected
        $( '[data-filter-menu-sort]' ).removeClass('selected');
        $button.addClass( "selected" );

        sort_loading = true;

        // close dropdown menu
        $( '.dropdown-sort-close' ).trigger( 'click' );

        // add loading icon
        $( '[data-filter-menu-sort-text]' ).html( loading_icon );

        // trigger filter on click event to update the list
        $( '[data-filter-menu] a.selected' ).trigger( "click" );
    });

});

// Reveal sidebar filter button when a input triggers the change event
document.addEventListener('DOMContentLoaded', function () {
    const searchForm = document.querySelector('form#search-form-search-page');
    const filterSidebarContainer = document.querySelector('.search-filter-sidebar');
    const sidebarFilterButton = document.querySelector('.sidebar-submit-facetsearch-button');
    if((typeof filterSidebarContainer != 'undefined') && (filterSidebarContainer != null)) {
        filterSidebarContainer.addEventListener('change', (event) => {
            searchForm.submit();
        });

        window.addEventListener('scroll', (event) => {
            // Get scroll position of bottom element
            const elScrollPos = filterSidebarContainer.offsetTop + (filterSidebarContainer.scrollHeight / 3);

            // Relocate button at the bottom of the filter sidebar
            if(screen.width > 1199 && window.scrollY > elScrollPos) {
                sidebarFilterButton.style.position = 'static';
            } else {
                sidebarFilterButton.style.position = 'fixed';
            }
        });
    }

    const findAllPostsButton = document.getElementById('find-all-posts');
    if ((typeof findAllPostsButton != 'undefined') && (findAllPostsButton != null)) {
        findAllPostsButton.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector('input[name="search_content"]').checked = true;
            searchForm.submit();
        });
    }
}, false);
